import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import userApi from '../../api/UserApi';
import * as commonSelectors from '../common/selectors';


const Timer = () => {
    const isAuthorized = useSelector(commonSelectors.isAuthorized);

    useEffect(() => {
        const tick = () => {
            if (isAuthorized === true) {
                const server = getCookie("authTicketExpirationInfo");
                if (server !== "") {
                    if (((server - 15) * 1000) <= (new Date()).getTime()) {
                        userApi.logoutSessionExpired();
                    }
                }
            }
        }

        const timer = setInterval(() => tick(), 15000);

        return () => clearInterval(timer);
    }, [isAuthorized]);

    return (
        <div>
            {isAuthorized === true && <div />}
        </div>
    );
}

function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export default Timer;